webpackJsonp([3,1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(103);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(95);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _HomePage = __webpack_require__(96);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/articles', component: _HomePage2.default }, {
	  path: '/articles/:number',
	  component: function component(resolve) {
	    __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(97)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, { path: '', redirect: '/articles' }, { path: '*', redirect: '/articles' }];
	
	var router = new _vueRouter2.default({
	  routes: routes
	});
	
	var app = new _vue2.default({
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('formatDate', function (value) {
	  return new Date(value).toLocaleString();
	});
	
	var formatDate = _vue2.default.filter('formatDate');
	
	exports.default = formatDate;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllIssues = exports.getSingleIssue = exports.getIssuesPage = undefined;
	
	var _marked = __webpack_require__(86);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _promise = __webpack_require__(22);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _common = __webpack_require__(49);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _sessionStorage = __webpack_require__(48);
	
	var _sessionStorage2 = _interopRequireDefault(_sessionStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseUrl = '/issues';
	
	function getIssuesPage(params) {
	  return new _promise2.default(function (resolve, reject) {
	    var allArticles = (0, _sessionStorage2.default)('articles');
	    if (!allArticles) {
	      (0, _common2.default)('get', baseUrl, params).then(function (data) {
	        var _data = _invertData(data);
	        resolve(_data);
	      }).catch(function (error) {
	        reject(error);
	      });
	    } else {
	      var _data = allArticles.slice((params.page - 1) * params.per_page, params.page * params.per_page);
	      resolve(_data);
	    }
	  });
	}
	
	function getSingleIssue(number) {
	  var url = baseUrl + '/' + number;
	  return new _promise2.default(function (resolve, reject) {
	    var allArticles = (0, _sessionStorage2.default)('articles');
	    if (!allArticles) {
	      (0, _common2.default)('get', url).then(function (data) {
	        var _data = _invertData([data])[0];
	        resolve(_data);
	      }).catch(function (error) {
	        reject(error);
	      });
	
	      setTimeout(getAllIssues, 500);
	    } else {
	      var _data = allArticles.filter(function (item) {
	        return item.number === number;
	      })[0];
	      resolve(_data);
	    }
	  });
	}
	
	function getAllIssues() {
	  return new _promise2.default(function (resolve, reject) {
	    var allArticles = (0, _sessionStorage2.default)('articles');
	    if (allArticles) {
	      resolve(allArticles);
	    } else {
	      (0, _common2.default)('get', baseUrl).then(function (data) {
	        resolve(data);
	        var articles = _invertData(data);
	        (0, _sessionStorage2.default)('articles', articles);
	      }).catch(function (error) {
	        reject(error);
	      });
	    }
	  });
	}
	
	function _invertData(arr) {
	  var articles = arr.map(function (item) {
	    return {
	      id: item.id,
	      number: item.number,
	      created_at: item.created_at,
	      title: item.title,
	      markdown: item.body,
	      html: (0, _marked2.default)(item.body),
	      html_url: item.html_url,
	      comments_url: item.html_url + '#partial-timeline-marker'
	    };
	  });
	  var reg = /<p>.+<\/p>/;
	  articles.forEach(function (item) {
	    var result = reg.exec(item.html);
	    item.summary = result ? result[0] : null;
	  });
	
	  return articles;
	}
	
	exports.getIssuesPage = getIssuesPage;
	exports.getSingleIssue = getSingleIssue;
	exports.getAllIssues = getAllIssues;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(87);
	
	exports.default = {
	  name: 'app',
	  created: function created() {
	    if (document.documentElement.clientWidth > 1000) {
	      window.particlesJS.load('particles-js', 'static/particles.json', function () {
	        console.log('callback - particles.js config loaded');
	      });
	    }
	  }
	};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pagination = __webpack_require__(98);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _issues = __webpack_require__(17);
	
	var _formatDate = __webpack_require__(16);
	
	var _formatDate2 = _interopRequireDefault(_formatDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home-page',
	  components: {
	    Pagination: _pagination2.default
	  },
	  data: function data() {
	    return {
	      articles: [],
	      totalArticles: '',
	      net_error: false,
	      params: {
	        per_page: 3,
	        page: 1
	      }
	    };
	  },
	  created: function created() {
	    this.getIssues();
	  },
	  watch: {
	    '$route': 'getIssues'
	  },
	  methods: {
	    getIssues: function getIssues() {
	      var _this = this;
	
	      window.scrollTo(0, 0);
	      if (!this.$route.query.page) {
	        this.params.page = 1;
	      } else {
	        this.params.page = parseInt(this.$route.query.page, 10);
	      }
	
	      (0, _issues.getIssuesPage)(this.params).then(function (data) {
	        _this.articles = data;
	      }).catch(function () {
	        return _this.net_error = true;
	      });
	
	      (0, _issues.getAllIssues)().then(function (data) {
	        return _this.totalArticles = data.length;
	      });
	    }
	  }
	};

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'pagination',
	  props: {
	    total: Number,
	    params: Object
	  },
	  data: function data() {
	    return {
	      pages: 1
	    };
	  },
	  created: function created() {
	    this.pages = Math.ceil(this.total / this.params.per_page);
	  },
	  methods: {
	    goPrevious: function goPrevious() {
	      this.$router.push({
	        path: 'articles',
	        query: {
	          page: this.params.page - 1
	        }
	      });
	    },
	    goNext: function goNext() {
	      this.$router.push({
	        path: 'articles',
	        query: {
	          page: this.params.page + 1
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var a = '27bf34f0055c3001573745';
	var b = '5d7c963fd5c0ac4eab';
	
	exports.default = {
	  api: 'https://api.github.com/repos/Hugo-seth/blog',
	  token: a + b
	};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(50);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.default = function (key, value) {
	  if (!key) {
	    console.log('setItem failed, must have one param or more');
	    return;
	  }
	  if (!value) {
	    return JSON.parse(sessionStorage.getItem(key));
	  } else {
	    sessionStorage.setItem(key, (0, _stringify2.default)(value));
	  }
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(51);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = function (method, url, params, body) {
	
	  var options = {
	    method: method,
	    url: _config2.default.api + url,
	    params: (0, _assign2.default)({}, params, { access_token: _config2.default.token }),
	    data: body
	  };
	  return new _promise2.default(function (resolve, reject) {
	    (0, _axios2.default)(options).then(function (response) {
	      if (response.status === 200) {
	        resolve(response.data);
	      } else {
	        reject(response.statusText.toString());
	      }
	    }).catch(function (error) {
	      if (error.response) {
	        console.log(error.response.status);
	        reject(error.response.status.toString());
	      } else {
	        console.log('Error', error.message);
	        reject(error.message.toString());
	      }
	    });
	  });
	};
	
	var _promise = __webpack_require__(22);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(25);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(47);
	
	var _config2 = _interopRequireDefault(_config);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(82)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(43),
	  /* template */
	  __webpack_require__(99),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(83)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(100),
	  /* scopeId */
	  "data-v-61461126",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(84)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(101),
	  /* scopeId */
	  "data-v-942b9adc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "app"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "particles-js"
	    }
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_c('h1', [_vm._v("Hugo's blog")])]), _vm._v(" "), _c('ul', {
	    staticClass: "nav"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "//github.com/Hugo-seth",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-github",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "//www.zhihu.com/people/shenqihui1992/",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "zhihu",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer"
	  }, [_c('p', [_vm._v("Copyright © Hugo's Blog 2017")])])
	}]}

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home-page"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.articles.length === 0 && !_vm.net_error),
	      expression: "articles.length === 0 && !net_error"
	    }],
	    staticClass: "spinner"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "article-list"
	  }, _vm._l((_vm.articles), function(article) {
	    return _c('li', [_c('router-link', {
	      attrs: {
	        "to": 'articles/' + article.number.toString()
	      }
	    }, [_c('h2', [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "article-summary",
	      domProps: {
	        "innerHTML": _vm._s(article.summary)
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "clearfix"
	    }, [_vm._v("阅读全文 "), _c('span', {
	      staticClass: "time"
	    }, [_vm._v("Posted at " + _vm._s(_vm._f("formatDate")(article.created_at)))])])])], 1)
	  })), _vm._v(" "), (_vm.net_error) ? _c('div', {
	    staticClass: "error-tip"
	  }, [_vm._v("暂时无法连接服务器，请稍后再来^_^")]) : _vm._e(), _vm._v(" "), (_vm.totalArticles) ? _c('div', [_c('pagination', {
	    attrs: {
	      "total": _vm.totalArticles,
	      "params": _vm.params
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "pagination"
	  }, [_c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.params.page !== 1),
	      expression: "params.page !== 1"
	    }]
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    domProps: {
	      "textContent": _vm._s('<')
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.goPrevious()
	      }
	    }
	  })]), _vm._v(" "), _vm._l((_vm.pages), function(n) {
	    return _c('li', {
	      class: {
	        current: _vm.params.page === n
	      }
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          path: 'articles',
	          query: {
	            page: n
	          }
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(n) + "\n    ")])], 1)
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.params.page !== _vm.pages),
	      expression: "params.page !== pages"
	    }]
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    domProps: {
	      "textContent": _vm._s('>')
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.goNext()
	      }
	    }
	  })])], 2)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.d6449c9.js